import { atom, useRecoilValue } from 'recoil'
import { CheckListInTopicType } from '../../services/web/types/requestWebServiceTypes'

export type ChecklistStoreType = {
    checklist: CheckListInTopicType[]
}
export const checklistStore = atom<ChecklistStoreType>({
    key: 'checklistStore',
    default: {
        checklist: [],
    },
})

const useChecklistStore = () => {
    const checklistState = useRecoilValue(checklistStore)
    return {
        ...checklistState,
    }
}

export default useChecklistStore
